import React from "react";

const Arrow = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 29" {...props}>
    <line x1="7.43" y1="0.78" x2="7.43" y2="17.93" />
    <polygon points="-0.05 15.74 7.43 28.7 14.91 15.74 -0.05 15.74" />
  </svg>
);

export default Arrow;
